// Card Block - Styled card with title and content
class CardBlock {
  static get toolbox() {
    return {
      title: 'Card',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      title: data.title || '',
      content: data.content || '',
      icon: data.icon || '',
      link: data.link || ''
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _render() {
    const CardContent = `
      <div class="p-4 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 hover:shadow-md transition-shadow" data-testid="card-block">
        ${!this.readOnly ? `
          <div class="flex gap-2 mb-3 pb-3 border-b border-slate-100 dark:border-slate-800">
            <input type="text" class="icon-input flex-1 px-2 py-1 text-xs rounded border" placeholder="Icon emoji" value="${this.data.icon}" />
            <input type="text" class="link-input flex-1 px-2 py-1 text-xs rounded border" placeholder="Link URL" value="${this.data.link}" />
          </div>
        ` : ''}
        <div class="flex items-start gap-3">
          ${this.data.icon ? `<span class="text-2xl">${this.data.icon}</span>` : ''}
          <div class="flex-1">
            <div class="card-title font-semibold text-slate-900 dark:text-white mb-1" contenteditable="${!this.readOnly}" data-placeholder="Card title">${this.data.title}</div>
            <div class="card-content text-sm text-slate-600 dark:text-slate-400" contenteditable="${!this.readOnly}" data-placeholder="Card content...">${this.data.content}</div>
          </div>
        </div>
      </div>
    `;

    this.wrapper.innerHTML = this.data.link && this.readOnly
      ? `<a href="${this.data.link}" class="block">${CardContent}</a>`
      : CardContent;

    if (!this.readOnly) {
      this.wrapper.querySelector('.icon-input')?.addEventListener('input', (e) => {
        this.data.icon = e.target.value;
        this._render();
      });
      this.wrapper.querySelector('.link-input')?.addEventListener('input', (e) => {
        this.data.link = e.target.value;
      });
      this.wrapper.querySelector('.card-title')?.addEventListener('input', (e) => {
        this.data.title = e.target.textContent;
      });
      this.wrapper.querySelector('.card-content')?.addEventListener('input', (e) => {
        this.data.content = e.target.innerHTML;
      });
    }
  }

  save() {
    return this.data;
  }
}

export default CardBlock;
